<template>
  <div>
    <b-modal id="deleteJobStatusModal" title="Confirm Deletion" centered>
      <template v-slot:modal-header>
        <div class="w-100">
          <h5 class="mb-0 header">Delete Status</h5>
        </div>
      </template>

      <div class="my-2">
        <p class="mt-2 mb-3 text-gray-700">Transfer any existing data to another status prior to deleting.</p>

        <div class="form-group">
          <label for="replacementStatus" class="form-label mb-2">Select Status</label>
          <select id="replacementStatus" v-model="selectedReplacementStatus" class="form-control" required>
            <option value="">Select</option>
            <option v-for="status in availableStatuses.filter(s => s.id !== targetStatusToDeleteId)" :key="status.id"
              :value="status.id">
              {{ status.name }}
            </option>
          </select>
        </div>
      </div>

      <template v-slot:modal-footer class="footer">
        <div class="w-100 d-flex justify-content-end gap-12">
          <button class="btn button-dark cancel-btn fw-normal" @click="close">
            Cancel
          </button>
          <button class="btn btn-danger fw-normal" @click="confirm" :disabled="!selectedReplacementStatus">
            Delete
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { MODAL_NAMES } from '../../utils/constants';

const { DELETE_JOB_STATUS_MODAL } = MODAL_NAMES;

export default {
  name: "modalDeleteJobStatus",
  props: {
    availableStatuses: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      targetStatusToDelete: null,
      selectedReplacementStatus: '',
    };
  },
  computed: {
    targetStatusToDeleteId() {
      return this.targetStatusToDelete ? this.targetStatusToDelete.id : null;
    }
  },
  methods: {
    open(status) {
      this.targetStatusToDelete = status;
      this.selectedReplacementStatus = '';
      this.$bvModal.show(DELETE_JOB_STATUS_MODAL);
    },
    close() {
      this.targetStatusToDelete = null;
      this.selectedReplacementStatus = '';
      this.$bvModal.hide(DELETE_JOB_STATUS_MODAL);
    },
    confirm() {
      this.$emit("confirmed", {
        status: this.targetStatusToDelete,
        replacementStatusId: this.selectedReplacementStatus
      });
      this.close();
    }
  }
};
</script>

<style scoped>
.header {
  color: #3A3A3A;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 27px;
}

.text-muted {
  color: #6c757d !important;
}

.cancel-btn {
  background-color: #EEF2F5 !important;
}

.form-label {
  font-size: 14px;
  color: #575759;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.form-control {
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  box-shadow: none;
}

.form-control:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control.is-invalid {
  border-color: #dc3545;
}

.form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 12px;
  color: #dc3545;
}

::v-deep .modal-footer {
  background: #FFFFFF !important;
  border-bottom: 1px solid #EBEBEB !important;
}

::v-deep #deleteJobStatusModal {
  overflow: hidden !important;
}

::v-deep .modal-header {
  border-bottom: 1px solid #EBEBEB !important;
}
</style>
